<template>
  <img
    :style="{
      width: height + 'px',
      height: height + 'px',
      marginRight: marginRight + 'px',
      marginLeft: marginLeft + 'px',
    }"
    :src="src"
    :alt="alt ? alt : code"
  />
</template>

<script>
export default {
  props: {
    code: String,
    height: {
      default: 30,
    },
    marginRight: {
      default: 10,
    },
    marginLeft: {
      default: 0,
    },
    alt: {
      default: "",
    },
  },

  computed: {
    src() {
      return `https://www.fivb.com/wp-content/themes/fivb/assets/images/flags/flag_${this.code.toLowerCase()}.png`;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Flag.vue